import { render, staticRenderFns } from "./PasswortReset.vue?vue&type=template&id=79b86b6a&scoped=true&"
import script from "./PasswortReset.vue?vue&type=script&lang=js&"
export * from "./PasswortReset.vue?vue&type=script&lang=js&"
import style0 from "./PasswortReset.vue?vue&type=style&index=0&id=79b86b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b86b6a",
  null
  
)

export default component.exports